import {
  Box,
  DialogTitle,
  Grid,
  Modal,
  TextField,
  Divider,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import manImage from "../../assets/male.png";
import femaleImage from "../../assets/female.png";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
// import { getAllCustomerDetail,  } from "./api";
import { searchedElementDisplay } from "../advancePayment/receiptFunctions";
import {
  getAllCustomerDetail,
  getLastDetail,
} from "../../common/searchModal/api";
import UserCard from "../advancePayment/userCard";
import { getAllIncentive } from "./paymentApi";
import { ModalHeader } from "../../common/modalHeader";
const PoprchModal = ({
  searchModal = false, // Ensure it's a boolean
  setSearchModal = () => {}, // Ensure it's a function
  config = {}, // Default to empty object
  callback = () => {}, // Default empty function
  cardValue = null, // Default null
  setCardValue = () => {}, // Default empty function
  // userDetail,
}) => {
  const [collection, setCollection] = useState([]);
  const [searchCurrentModal, setSearchCurrentModal] = useState("");
  const getCounterSalesCusomter = async (param) => {
    // await getCounterSalesCustomers(param).then((res) => {
    //   console.lo g("countersales res data   ", res?.data?.data, " ", {
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   setPagination({
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   console.log("res?.data",res?.data?.data?.list)
    //   setUnPaidBill([...res?.data?.data?.list]);
    // });
  };
  useEffect(() => {
    console.log("dddd");
    if (searchModal === true) {
      getAllIncentive((data) => {
        console.log("data detail ", data?.data?.data?.list);
        setCollection(data?.data?.data?.list);
      });
      //   getCounterSalesCusomter({
      //     filter: "",
      //     search: "",
      //     page: 1,
      //     pageSize: 1000,
      //   });
      //   setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {
      console.log("close");
      //   setBillData(data);
      //   setUnPaidBillData();
      //   setSearchCurrentModal("")
    }
  }, [searchModal]);
  return (
    <Modal
      open={searchModal}
      sx={{ zIndex: 999999 }} // Yo
      onClose={() => {
        setSearchCurrentModal("");
        setSearchModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid
        container
        sx={{
          // backgroundColor: "white",
          // width:"40%"
          background: "white",
          width: { xs: "95%", sm: "85%", md: "70%", lg: "60%", xl: "50%" },

          overflowY: "auto",
          height: "80vh",
          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "5%", md: "10%", lg: "15%", xl: "20%" },

          top: "10%",
        }}
      >
        <Grid item xs={12}>
          <ModalHeader
            title={"Employee List"}
            onClose={() => {
              setSearchCurrentModal("");
              setSearchModal(false);
            }}
          />
          <Divider />
          <Grid container>
            <Grid item xs={12}>
              <Box sx={{ mt: 1, textAlign: "center", px: "20px", mb:2 }}>
                <TextField
                  sx={{
                    width: "100%",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  size="small"
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                  label="Search by Name/Mobile Number"
                  value={searchCurrentModal}
                  onChange={(e) => {
                    setSearchCurrentModal(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <SearchIcon
                        sx={{
                          color: (theme) => theme.palette.primary.main,
                        }}
                      />
                    ),
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ height: "65vh", overflowY: "auto", paddingRight: "10px" }}
            >
              <Grid container>
                {collection
                  .filter((item) => {
                    const name =
                      item.name ||
                      item.employeeName ||
                      item.emaployeeName ||
                      "";

                    return name
                      .toLowerCase()
                      .includes(searchCurrentModal.toLowerCase().trim());
                  })
                  .map((item, index) => {
                    if (config?.salary && item?.salaryorPercentage !== true) {
                      return null;
                    }
                    return (
                      <>
                        {/* <UserCard
                        key={"employee" + index}
                        data={item}
                        callBack={(data) => {
                          setCardValue(data);
                          setSearchModal(false);
                        }}
                      /> */}
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          key={"tableListBill" + index}
                          sx={{
                            padding: "8px 20px",
                          }}
                        >
                          <Box
                            onClick={() => {
                              setCardValue(item);
                              setSearchModal(false);
                            }}
                            sx={{
                              margin: "0px 10px",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "start",
                              backgroundColor: "#EEEEFF",
                              alignItems: "center",
                              width: "100%",
                              fontWeight: "bold",
                              height: "70px",
                              borderRadius: "6px",
                            }}
                          >
                            <Box
                              component="img"
                              src={
                                item.gender === "female" ||
                                item.gender === "Female"
                                  ? femaleImage
                                  : manImage
                              }
                              sx={{
                                width: "39px",
                                borderRadius: "50%",
                                marginX: "20px",
                              }}
                            />
                            <Box>
                              <Typography
                                sx={{
                                  fontSize: {
                                    xs: "14px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontFamily: "'Montserrat', sans-serif",
                                }}
                              >
                                Emp ID: {}
                                <Typography
                                  component="span"
                                  color="primary"
                                  sx={{
                                    fontSize: {
                                      xs: "14px",
                                      sm: "13px",
                                      md: "15px",
                                    },
                                    fontWeight: 500,
                                    fontFamily: "'Montserrat', sans-serif",
                                  }}
                                >
                                  {item.employeeId ?? "NA"}
                                </Typography>
                              </Typography>
                              <Typography
                                color="primary"
                                sx={{
                                  fontSize: {
                                    xs: "14px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  fontWeight: 600,
                                  fontFamily: "'Montserrat', sans-serif",
                                }}
                              >
                                {item.name ||
                                  item.employeeName ||
                                  item.emaployeeName ||
                                  "Unknown"}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      </>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default PoprchModal;
